import PropTypes from "prop-types";
import ProcessDoneIcon from "./ProcessDoneIcon";
import { Tooltip, Typography } from "@mui/material";
import ProgressCirc from "src/components/layout/Progress/ProgressCirc";
import { aikaPvmStringLong } from "src/components/js/statics1";
import HelperIcon from "src/components/icons/purposed/HelperIcon/HelperIcon";

const styles = {
  flex: { display: "flex" },
  txtDivPointer: { cursor: "pointer", width: "60%" },
  txtDivNoPointer: { cursor: "inherit", width: "60%" },
};

export default function ProcessRow(props) {
  const show = props.show === undefined ? true : props.show;
  if (!show) return null;

  const done = props.done || false;
  const pvm = props.pvm || null;
  const pvm2 = props.pvm2 || null;
  const isLoading = props.isLoading === undefined ? false : props.isLoading;
  const hideDate = props.hideDate || false;
  const disableCheckClick = props.disableCheckClick || false;
  const disableTextClick = props.disableTextClick || false;
  const handleCheckClick = () =>
    props.onCheckClick ? props.onCheckClick() : props.onClick ? props.onClick() : null;
  const handleTextClick = () =>
    props.onTextClick ? props.onTextClick() : props.onClick ? props.onClick() : null;
  const txt = props.txt || "Teksti puuttuu";
  const textTip = ""; // props.textTip || props.tip || null;
  const checkTip = ""; // props.checkTip || props.tip || null;
  const helpId = props.helpId || null;

  //if (!enabled) tip = null;
  return (
    <div style={styles.flex}>
      <div style={{ width: "10%", height: "30px" }}>
        {isLoading ? (
          <div style={{ width: "30px", height: "100%" }}>
            <ProgressCirc />
          </div>
        ) : (
          <Tooltip
            disableInteractive
            title={ToolTipCheckTitle(checkTip)}
            placement="top-start"
            arrow>
            <div>
              <ProcessDoneIcon
                done={done}
                onClick={() => !disableCheckClick && handleCheckClick()}
                aria-label="Valmis"
                disabled={disableCheckClick}
              />
            </div>
          </Tooltip>
        )}
      </div>

      {txt && (
        <div
          style={!disableTextClick ? styles.txtDivPointer : styles.txtDivNoPointer}
          onClick={() => !disableTextClick && handleTextClick()}
          aria-label="Valmis">
          <Tooltip disableInteractive title={ToolTipTextTitle(textTip)} placement="top-start" arrow>
            <div>
              <Typography variant="body" color="primary" className="fixPrint">
                {txt}
              </Typography>
            </div>
          </Tooltip>
        </div>
      )}
      <div style={{ width: "30%" }}>
        {pvm && done && !hideDate && (
          <>
            <Typography variant="body2" color="primary">
              {aikaPvmStringLong(pvm, true)}
            </Typography>
            {pvm2 && (
              <Typography variant="body2" color="primary">
                klik:{aikaPvmStringLong(pvm2, true)}
              </Typography>
            )}
          </>
        )}
      </div>
      {props.children}
      {helpId && <HelperIcon helpId={helpId} />}
    </div>
  );

  function ToolTipCheckTitle(txt) {
    if (disableCheckClick) return null;
    if (txt === null || txt === "") return null;
    return <Typography fontSize={14}>{txt}</Typography>;
  }
  function ToolTipTextTitle(txt) {
    if (disableCheckClick) return null;
    if (txt === null || txt === "") return null;
    return <Typography fontSize={14}>{txt}</Typography>;
  }
}

ProcessRow.propTypes = {
  done: PropTypes.bool,
  txt: PropTypes.string,
  children: PropTypes.node,
  pvm: PropTypes.instanceOf(Date),
  pvm2: PropTypes.instanceOf(Date),
  onClick: PropTypes.func,
  tip: PropTypes.string,
  isLoading: PropTypes.bool,
  hideDate: PropTypes.bool,
  disableCheckClick: PropTypes.bool,
  disableTextClick: PropTypes.bool,
  onCheckClick: PropTypes.func,
  onTextClick: PropTypes.func,
  textTip: PropTypes.string,
  checkTip: PropTypes.string,
  helpId: PropTypes.string,
  show: PropTypes.bool,
};
